import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';
import { BannerEntityService } from '@views/pages/apps/settings/banners/services/banner-entity.service';


@Injectable()
export class BannerResolver implements Resolve<boolean> {

    constructor(private bannerService: BannerEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.bannerService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.bannerService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }

}
